import { hasProperty, isEmpty } from "../validate";

export const getDealerPrincipleEmail = (dealer) => {

	let returnPrincipleEmails = [];

	if (hasProperty(dealer, 'dealerPrincipleEmail') && dealer.dealerPrincipleEmail) {
		const principleEmail = dealer.dealerPrincipleEmail;

		if (principleEmail.includes(',')) {
			const principleEmailList = principleEmail.split(',');
			returnPrincipleEmails = principleEmailList;
		} else {
			returnPrincipleEmails.push(principleEmail);
		}
	}

	return returnPrincipleEmails[0]
}

export const getDealerEmailList = (formData, field, dealer, returnFormat = 'string') => {

	const { form } = formData;
	const handle = form.handle
	const { dealerType } = dealer;

	let emailList = [];

	if (hasProperty(dealer, 'contactUsEmail') && !(isEmpty(dealer.contactUsEmail))) {
		emailList = dealer.contactUsEmail.replace(/\s/g, '');
	}

	if (dealerType === "parts") {
		if (hasProperty(dealer.parts, 'contactUsEmail')){
			emailList = dealer.parts.contactUsEmail.replace(/\s/g, '');
		}
	}

	if (dealerType === "service") {
		if (hasProperty(dealer.service, 'contactUsEmail')){
			emailList = dealer.service.contactUsEmail.replace(/\s/g, '');
		}
	}

	if (handle === 'requestAPartCars' || handle === 'requestAPartMotorcycles') {
		if (hasProperty(dealer, 'parts') && hasProperty(dealer.parts, 'contactUsEmail') && !(isEmpty(dealer.parts.contactUsEmail))) {
			emailList = dealer.parts.contactUsEmail.replace(/\s/g, '');
		};
	}

	if (handle === 'bookAServiceCars' || handle === 'bookAServiceMotorcycles') {
		if (hasProperty(dealer, 'service') && hasProperty(dealer.service, 'contactUsEmail') && !(isEmpty(dealer.service.contactUsEmail))) {
			emailList = dealer.service.contactUsEmail.replace(/\s/g, '');
		};
	}

	// Check if we need to convert to an array.
	if (!isEmpty(emailList) && emailList.includes(',')){

		emailList = emailList.split(',');

		if (!isEmpty(dealer.dealerPrincipleEmail)) {
			emailList.push(dealer.dealerPrincipleEmail);
		}

		if (Array.isArray(emailList) && emailList.length > 1){
			emailList = emailList.filter((item, index) => emailList.indexOf(item) === index);
			let filteredEmailList = Array.from(new Set(emailList))
			if (filteredEmailList.length == 0){
				emailList[0] = getDealerPrincipleEmail(dealer);
			}
		}

		emailList = emailList;
	}

	if (emailList == "" || isEmpty(emailList)){
		emailList = [];
		emailList.push(getDealerPrincipleEmail(dealer))
	}

	if (returnFormat == 'arr' || returnFormat == 'array'){
		return Array.isArray(emailList) ? emailList : [emailList];
	}

	if (returnFormat == 'string'){
		return Array.isArray(emailList) ? emailList[0] : emailList;
	}
}

export const getBlockId = block => block.data && "navTitle" in block.data && block.data.navTitle ? block.data.navTitle.toLowerCase().replace(/ /g, '_') : '';
